import { render } from "./Contact.vue?vue&type=template&id=f8df19c4&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=f8df19c4&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-f8df19c4"

export default script